
export class EvalError  {
    name:string;
    message:string;
	constructor(msg:string) {
		this.name="EVAL";
		this.message=msg;    		
	}
} 



// WEBPACK FOOTER //
// ./src/app/error/eval-error.ts